import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';

import VrmUlezChecker from '../../../../../components/vrm/VrmUlezChecker/VrmUlezChecker';

import styles from './Hero.scss';

type UlezHeroProps = {
  eyebrow?: string;
  subTitle?: string;
  title?: string;
};

const Hero = ({ eyebrow, subTitle, title }: UlezHeroProps) => (
  <div className={styles.heroSection}>
    <Content className={styles.content}>
      <div className={styles.container}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.desc}>{subTitle}</p>
      </div>
      <VrmUlezChecker />
    </Content>
  </div>
);

export default Hero;
